var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumPredisposition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.243,
    height: 15.641,
    viewBox: "0 0 17.243 15.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21003",
    "data-name": "Path 21003",
    d: "M29.4,17.036a1.989,1.989,0,0,1,3.433,1.992l-.042.084a1.989,1.989,0,0,0,1.65,2.864h0a1.989,1.989,0,0,1,0,3.969h0a1.989,1.989,0,0,0-1.65,2.864l.042.084A1.989,1.989,0,0,1,29.4,30.885l-.076-.113a1.989,1.989,0,0,0-3.3,0l-.076.113a1.989,1.989,0,0,1-3.433-1.992l.042-.084a1.989,1.989,0,0,0-1.65-2.864h0a1.989,1.989,0,0,1,0-3.969h0a1.989,1.989,0,0,0,1.65-2.864l-.042-.084a1.989,1.989,0,0,1,3.433-1.992l.076.113a1.989,1.989,0,0,0,3.3,0Z",
    transform: "translate(-19.049 -16.14)",
    fill: "#4E860D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumPredisposition);
export default __webpack_public_path__ + "static/media/medium-predisposition.c25697f21e189c7f73db23e3dbe6f504.svg";
export { ForwardRef as ReactComponent };